import { ref } from "vue";

// Old visit-based flags must not grant access under the signup-only rules.
export const FREE_TRIAL_STORAGE_KEY = "clubhouse.freeTrialSignup";

const isActive = ref(false);

function readStoredValue(): boolean {
  try {
    return localStorage.getItem(FREE_TRIAL_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function syncFromStorage(value: string | null): void {
  isActive.value = value === "true";
}

function writeStoredValue(value: boolean): void {
  try {
    if (value) {
      localStorage.setItem(FREE_TRIAL_STORAGE_KEY, "true");
    } else {
      localStorage.removeItem(FREE_TRIAL_STORAGE_KEY);
    }
    syncFromStorage(value ? "true" : null);
  } catch {
    isActive.value = false;
  }
}

if (typeof window !== "undefined") {
  isActive.value = readStoredValue();
  window.addEventListener("storage", (event) => {
    if (event.key === FREE_TRIAL_STORAGE_KEY) {
      syncFromStorage(event.newValue);
    }
  });
}

export function useFreeTrialContext() {
  function activate(): boolean {
    writeStoredValue(true);
    return isActive.value;
  }

  function clear(): void {
    writeStoredValue(false);
  }

  function clearIfUserHasSubscription(subscription: unknown): void {
    if (subscription !== null && subscription !== undefined) {
      clear();
    }
  }

  return {
    isActive,
    activate,
    clear,
    clearIfUserHasSubscription,
    storageKey: FREE_TRIAL_STORAGE_KEY,
  };
}
